import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {environment} from '../../../../environments/environment';
import {Utilisateur} from '../../../interface/api/Utilisateur';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {ModalConfirmationComponent} from '../modal-confirmation/modal-confirmation.component';
import {MatDialog} from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Subscription} from 'rxjs';
import {ToolsService} from '../../services/tools/tools.service';
import {FichierInterface} from '../../../class/api/Fichier';
import { NgStyle } from '@angular/common';
import { MatList, MatListItem, MatListItemTitle, MatListItemLine } from '@angular/material/list';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-file-uploader',
    templateUrl: './file-uploader.component.html',
    styleUrls: ['./file-uploader.component.scss'],
    providers: [HydraService],
    imports: [FormsModule, ReactiveFormsModule, NgStyle, MatList, MatListItem, MatListItemTitle, MatIconButton, MatTooltip, MatIcon, MatListItemLine, TranslateModule]
})
export class FileUploaderComponent implements OnInit {
    private hydraService = inject(HydraService);
    translate = inject(TranslateService);
    private toolService = inject(ToolsService);
    private dialog = inject(MatDialog);

    public idComponent = '';

    @ViewChild('myFiles') myFiles: ElementRef;
    public Upload = new HydraCollection();
    public files: FichierInterface[] = [];
    public subscriptions: Subscription[] = [];

    @Input() readonly = false;

    /**
     * @todo : renommer en "files"
     * @param value
     */
    @Input() set file(value: FichierInterface | FichierInterface[]) {
        if (value == null) {
            this.files = [] as FichierInterface[];
            this.ctrl = new FormControl<FichierInterface|string|null>('', []);
        } else if (Array.isArray(value)) {
            this.files = value;
        } else {
            this.files = [];
            this.files.push(value);
        }
    }

    /*
        @Input("fileNameEditable")  set fileNameEditable(value : boolean) {
            if(value != undefined){
                this.changeFileName = value;
            }
        }*/
    @Input() cacheChamp = false;

    private _disabled: boolean = false;
    @Input() set disabled(value) {
        this._disabled = value;
        if (value == true) {
            this.ctrl.disable();
        } else {
            this.ctrl.enable();
        }
    }
    get disabled(): boolean {
        return this._disabled;
    }

    @Input('placeholder') messageChoisirFichier?: string = 'front.candidature.choisirFichier';
    @Input('MaxSize') size = 10;
    @Input() key?: string = null;
    @Input('ext') extension?: string[] = environment.extantions.documents;
    @Input() beforeFilesContainer?: string = '';
    fileUploadValid = false;
    errorMessage = '';
    acceptedExt = '';
    @Input() type?: string = '';
    @Input() maxFiles?: number = 1;
    @Input() tempHackAnnexesAvantRefacto?: boolean = false;
    @Input() ctrl?: FormControl<FichierInterface|string|null> = new FormControl();
    @Input() forceOwner?: Utilisateur = null;
    @Input() forceRemoveBeforeChange: boolean = false;
    @Input() showChangeFileName: boolean = true;


    @Output() AfterSave: EventEmitter<any> = new EventEmitter();

    /**
     * @deprecated cet event emmitter est mal nommé, et ne permet pas d'identitfier clairement l'élément supprimé
     */
    @Output() RemoveAfterSave: EventEmitter<any> = new EventEmitter();
    @Output() RemovedFile: EventEmitter<{ removedFile: FichierInterface; files: FichierInterface[] }> = new EventEmitter();


    @Output() OnFileChange: EventEmitter<any> = new EventEmitter<any>();


    private messageExtentionIncorrect = 'front.candidature.extentionIncorrect';
    private messageTailleIncorrect = 'front.candidature.tailleFichierIncorrect';
    private messageMaxFichier = 'front.candidature.nbMaxFichier';
    private messageFichier = 'front.candidature.fichiers';

    constructor() {
        this.idComponent = this.toolService.getGUID();
        this.getTranslations();
    }

    ngOnInit() {
        this.translate.onLangChange.subscribe(res => {
            this.getTranslations();
        });
        this.concatExt();
    }


    public getTranslations() {
        this.subscriptions.push(this.translate.get('front.candidature.choisirFichier').subscribe(res => this.messageChoisirFichier = res));
        this.subscriptions.push(this.translate.get('front.candidature.extentionIncorrect').subscribe(res => this.messageExtentionIncorrect = res));
        this.subscriptions.push(this.translate.get('front.candidature.tailleFichierIncorrect').subscribe(res => this.messageTailleIncorrect = res));
        this.subscriptions.push(this.translate.get('front.candidature.nbMaxFichier').subscribe(res => this.messageMaxFichier = res));
        this.subscriptions.push(this.translate.get('front.candidature.fichiers').subscribe(res => this.messageFichier = res));
    }

    public download(file) {
        return this.toolService.download(file);
    }

    public getFileExtension(filename: string): string {
        const parts = filename.split('.');

        return parts[parts.length - 1].toLowerCase();
    }

    public verifExt() {
        if (this.myFiles.nativeElement.files.length) {
            let pass = true;
            const files = this.myFiles.nativeElement.files;
            for (let i = 0; i < files.length; i++) {
                const passFile = this.extension.includes(
                    this.getFileExtension(
                        this.myFiles.nativeElement.files[i].name
                    )
                );
                if (!passFile) {
                    pass = false;
                }
            }
            return pass;
        } else {
            return false;
        }
    }

    public validSize() {
        const size = this.size * 1024 * 1024;
        const files = this.myFiles.nativeElement.files;

        for (let i = 0; i < files.length; i++) {
            if (files[i].size > size) {
                return false;
            }
        }

        return files.length + this.files.length <= this.maxFiles;
    }

    public onFileChange(event) {
        if (event && event.target && event.target.files && event.target.files.length) {
            this.errorMessage = '';
            this.fileUploadValid = true;

            if (this.maxFiles && this.maxFiles == 1 && this.tempHackAnnexesAvantRefacto) {
                this.files = [];
            }


            if (this.verifExt() && this.validSize()) {
                this.fileUploadValid = true;
                this.changeCSS(this.myFiles);
                this.OnFileChange.emit(true);
            } else {
                this.errorMessage = '';
                this.errorMessage += !this.verifExt()
                    ? this.messageExtentionIncorrect
                    : '';
                if (this.errorMessage.length) {this.errorMessage += '\n';}
                this.errorMessage += !this.validSize()
                    ? this.messageTailleIncorrect
                    : '';
                if (
                    this.myFiles.nativeElement.files.length + this.files.length >
                    this.maxFiles
                ) {
                    this.errorMessage +=
                        this.messageMaxFichier + ' : ' + this.maxFiles;
                }
                this.fileUploadValid = false;
            }

        }


    }

    /**
     * @deprecated Ce composant ne devrait pas gérer la sauvegarde. utiliser plutôt le data-binding pour la liste des fichiers
     * @param type
     */
    public save(type: string = this.type) {
        if (this.myFiles.nativeElement.files.length) {
            const files = this.myFiles.nativeElement.files;
            let counter = 0;
            for (let i = 0; i < files.length; i++) {
                const file = this.myFiles.nativeElement.files[i];

                /*   if(this.changeFileName && this.fileName.length){
                       file.name = this.changeFileName;
                   }*/

                const sub = this.hydraService.upload(file, type, this.forceOwner).subscribe(
                    (res: FichierInterface) => {
                        this.files.push(res);
                        counter++;
                        if (counter == this.myFiles.nativeElement.files.length) {
                            this.myFiles.nativeElement.value = '';
                            this.AfterSave.emit(this.files);
                        }
                        sub.unsubscribe();
                    });
            }
        }
    }

    public delete(file = null, index: number) {
        if (file != null) {
            const confirm = this.dialog.open(ModalConfirmationComponent, {
                panelClass: 'arc-dialog-panel', backdropClass: 'arc-dialog-backdrop'
            });
            const sub = confirm.afterClosed().subscribe(res => {
                if (res) {
                    this.files.splice(index, 1);

                    this.RemoveAfterSave.emit(file);
                    this.RemovedFile.emit(
                        {
                            removedFile: file,
                            files: this.files
                        });

                    this.errorMessage = '';
                    const nativeElement = this.myFiles?.nativeElement;
                    if(nativeElement){
                        nativeElement.value = '';
                    }

                    document.getElementById(this.idComponent)?.setAttribute('data-value', this.messageChoisirFichier + '...');
                }
                sub.unsubscribe();
            });

        }
    }

    private timerLabel;
    public saveLabel(file) {
        if(file['@id'] !== null) {
            if (this.timerLabel) {
                //if there is already a timeout in process cancel it
                window.clearTimeout(this.timerLabel);
            }
            if(file.label?.trim() === '') {
                file.label = null;
            }
            this.timerLabel = window.setTimeout(() => {
                this.timerLabel = null;
                this.hydraService.put(file['@id'], {label: file.label}).subscribe(() => {});
            }, 500);

        }
    }

    public changeCSS(file) {
        let fileName = '';
        if (this.myFiles.nativeElement.files.length == 1) {
            fileName = this.myFiles.nativeElement.files[0].name;
        } else {
            fileName = this.myFiles.nativeElement.files.length + ' ' + this.messageFichier;
        }

        document
            .getElementById(this.idComponent)
            .setAttribute('data-value', fileName);
    }

    public reset() {
        this.myFiles.nativeElement.value = null;
        document
            .getElementById(this.idComponent)
            .setAttribute('data-value', this.messageChoisirFichier + '...');
    }

    public concatExt() {
        if(this.extension.length > 1) {
            this.acceptedExt = '.' + this.extension.join(', .');
        }
        else if(this.extension.length == 1) {
            this.acceptedExt = '.' + this.extension[0];
        }
        else {
            this.acceptedExt = '*';
        }
    }

    isValid() {
        return this.validSize() && this.verifExt();
    }
}
